module.exports = __webpack_public_path__ + "static/logo33-a988d08583077661aa8aae144000c2b7.png";